import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-product-drag-preview',
  templateUrl: './product-drag-preview.component.html',
  styleUrl: './product-drag-preview.component.scss'
})
export class ProductDragPreviewComponent {
  @Input() item: any; 
}
